import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GeetzLogin from '../../assets/GeetzLogo';
import ChatIcon from '../../assets/Header/ChatIcon';
import LeftSearchBar from '../../assets/Header/LeftSearchBar';
import NotificationIcon from '../../assets/Header/NotificationIcon';
import OptionsIcon from '../../assets/Header/OptionsIcon';
import PlusIcon from '../../assets/Header/PlusIcon';
import RightSearchBar from '../../assets/Header/RightSearchBar';
import SearchIcon from '../../assets/Header/SearchIcon';
import { useAuth } from '../../contexts/auth';
import { useMessages } from '../../contexts/messages';
import { useModals } from '../../contexts/modals';
import Button from '../Button';
import ChatBox from '../ChatBox';
import PublicationModal from '../Modals/PublicationModal';
import UserIcon from '../UserIcon';
import { Container, CreateProjectButton, FormContainer, HeaderLink, HeaderLinksContainer, Icon, IconsWrapper, InnerContainer, LogoWrapper, SearchContainer, SearchIconWrapper, SearchInput } from './styles';

export default function Header() {
  const navigate = useNavigate();
  const [createModal, setCreateModal] = useState(false);
  const { signOut, user } = useAuth();
  const { chatModal, setChatModal, chatSolicitations } = useMessages();
  const { showContextModal } = useModals();

  const handleCloseModal = () => {
    setCreateModal(false)
  }
  const [isProfile, setIsProfile] = useState(false);
  useEffect(() => {
    const routeArgs = window.location.pathname.split('/')
    if (routeArgs[1] === 'Profile') {
      setIsProfile(true)
    }
  }, []);

  const leave = () => {
    navigate('/')
    signOut()
  }

  return (
    <Container style={{ backgroundColor: isProfile ? 'transparent' : '#fff' }}>
      <InnerContainer>
        <LogoWrapper onClick={() => navigate('/')}>
          <GeetzLogin />
        </LogoWrapper>
        <HeaderLinksContainer>
          <HeaderLink style={{ color: '#6E30E8' }}>
            Social
          </HeaderLink>
          <HeaderLink onClick={() => showContextModal('', true, 'Em breve!')}>
            Central indie
          </HeaderLink>
          <HeaderLink>
            Crowdfunding
          </HeaderLink>
          <HeaderLink>
            Marketplace
          </HeaderLink>
          <HeaderLink>
            Explorar
          </HeaderLink>
        </HeaderLinksContainer>
        <SearchContainer>
          <LeftSearchBar color={"#D9D9D9"} />
          <FormContainer>
            <SearchIconWrapper>
              <SearchIcon color={"#4D4D4D"} />
            </SearchIconWrapper>
            <SearchInput placeholder="Buscar" />
          </FormContainer>
          <RightSearchBar color={"#D9D9D9"} />
          <CreateProjectButton onClick={() => setCreateModal(true)}>
            {/* <PixelButton label="+ Criar" color="rgba(110, 48, 233, 1)" onClick={() => {}} /> */}
            <PlusIcon />
          </CreateProjectButton>
          {createModal && <PublicationModal open={createModal} onClose={handleCloseModal} />}
        </SearchContainer>
        <IconsWrapper>
          <Icon onClick={() => setChatModal(!chatModal)}>
            <div style={{ position: 'absolute', width: 16, height: 16, marginLeft: 12, borderRadius: 5, backgroundColor: 'red', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <p style={{ color: '#fff', fontSize: 10, textAlign: 'center' }}>
                {chatSolicitations}
              </p>
            </div>
            <ChatIcon color={"#D9D9D9"} />
          </Icon>
          <ChatBox open={chatModal} onClose={setChatModal} />
          <Icon>
            <NotificationIcon color={"#D9D9D9"} />
          </Icon>
          <Icon onClick={() => navigate(`/Profile/${user?.username}`)}>
            <UserIcon icon={user?.avatarUrl || 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png'} size="m" isOnline={false} />
          </Icon>
          <Icon>
            <OptionsIcon />
          </Icon>
          <Button theme="light" text="Sign Out" onClick={() => leave()} />
        </IconsWrapper>
      </InnerContainer>
    </Container>
  )
}
